import React from 'react';
import styled from '@emotion/styled';
import { useLocale, useTexts } from '@devsisters/gatsby-plugin-i18n';
import $ from 'text2vdom';

import { scaledCss } from '~/src/css';
import { SectionWithTitle } from '~/src/components/bravecookies/section';
import StoreLink from '~/src/components/StoreLink';

interface HowToProps {}
const HowTo: React.FC<HowToProps> = () => {
  const locale = useLocale();
  const t = useTexts();
  const seqNum = locale === 'ko' ? ['첫째', '둘째', '셋째'] : ['01', '02', '03'];
  return (
    <HowToSection title={t`$howto.title`}>
      <HowToItem>
        <SequenceNumber>{seqNum[0]}</SequenceNumber>
        <div>{$$(t`$howto.description.01`)}</div>
      </HowToItem>
      <StoreLink href="https://go.onelink.me/nbbb/a9cd3141" />
      <HowToItem>
        <SequenceNumber>{seqNum[1]}</SequenceNumber>
        <div>{$$(t`$howto.description.02`)}</div>
      </HowToItem>
      <br />
      <HowToItem>
        <SequenceNumber>{seqNum[2]}</SequenceNumber>
        <div>{$$(t`$howto.description.03`)}</div>
      </HowToItem>
    </HowToSection>
  );
};

export default HowTo;

const $$: typeof $ = (text, customComponents) => {
  return $(text, {
    small: ({ children }) => <Small>{children}</Small>,
    ...customComponents,
  });
};

const Small = styled('span')(
  scaledCss({
    letterSpacing: '-0.5em',
  })
);

const HowToSection = styled(SectionWithTitle)(
  scaledCss({
    display: 'flex',
    flexDirection: 'column',
    marginX: [25, '25px'],
    paddingTop: [70, '70px'],
    paddingBottom: [45, '45px'],
    paddingLeft: [55, '55px'],
    paddingRight: [40, '40px'],
    lineHeight: 1.5,
    fontSize: [30, '30px'],
  })
);

const HowToItem = styled('div')(
  scaledCss({
    margin: 0,
    display: 'flex',
    '& strong': {
      color: '#2f61e1',
      fontWeight: 'inherit',
    },
  })
);

const SequenceNumber = styled('span')(
  scaledCss({
    color: '#2f61e1',
    whiteSpace: 'nowrap',
    '&:after': {
      content: '".\\00a0"',
    },
    '&:lang(ko)': {
      '&:after': {
        content: '",\\00a0"',
      },
    },
  })
);
